import Device from '../../../../../constants/deviceSizes';

export default {
  container: {
    height: '100%'
  },
  table: {
    height: 'calc(100% - 130px)'
  },
  mobileTypeContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    width: '100%',
    padding: '5px 6px'
  },
  arrow: {
    position: 'absolute',
    right: 20,
    transform: 'rotate(90deg)'
  },
  normalDetail: {
    width: '90%',
    display: 'flex',
    justifyContent: 'flex-end',
    [Device.mobile]: {
      width: 'auto'
    }
  },
  rateValueStyle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between'
  },
  nullRateValueStyle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end'
  }
};
